import { TOrderEntryFormValues, TOrderEntryPayload } from '../types'
import { fixAddress } from './addressUtils'

export default function getValuesFromExternal(
  values: TOrderEntryPayload,
): TOrderEntryFormValues {
  const {
    pickupAddress,
    deliveryAddress,
    invoiceAddress,
    defaultSlaType,
    defaultSlaTypeId,
    ...rest
  } = values
  // console.log("getValuesFromExternal", values)
  return {
    ...rest,
    pickup: { address: fixAddress(pickupAddress) },
    delivery: {
      address: fixAddress(deliveryAddress),
    },
    invoice: {
      address: fixAddress(invoiceAddress),
    },
    // defaultSla: defaultSlaType,
    // defaultSlaTypeId,
    // neutralSender: lodash.pickBy({
    //   address: fixAddress(neutralSenderAddress)
    // })
    bookingRecords: [],
  }
}
